import React, { useState } from "react";
import { Button, Card, Table, Typography } from "antd";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import FileUploadButton from "../lib/common/FileUploadButton";
import { useAPI } from "../lib/hook/APIProvider";
import DataCompareModal from "./DataCompareModal";
import { useModal } from "../lib/modal/ModalContext";
import BarChartOutlined from "@ant-design/icons/BarChartOutlined";
import CheckOutlined from "@ant-design/icons/CheckOutlined";
import DeleteOutlined from "@ant-design/icons/DeleteOutlined";
import DownloadOutlined from "@ant-design/icons/DownloadOutlined";
import FileTextOutlined from "@ant-design/icons/FileTextOutlined";
import RollbackOutlined from "@ant-design/icons/RollbackOutlined";
import ToolOutlined from "@ant-design/icons/ToolOutlined";
import UploadOutlined from "@ant-design/icons/UploadOutlined";

import ModalBase from "../lib/common/ModalBase";
const ReportBatchRemover: React.FC = () => {
  const reportTableNames = [
    "CUSDEC5SCB1",
    "CUSDEC5SCA1",
    "CUSDEC929C1",
    "CUSDEC929B1",
    "CUSDEC929A1",
    "CUSVAL934",
  ];
  const [loading, setLoading] = useState(false);

  const { client } = useAPI();
  const { hideModal, showModal } = useModal();

  const OnDelete = async () => {
    setLoading(true);
    for (const tableName of reportTableNames) {
      const result = await client.delete(
        `preview/bmw/${tableName}/?key=Rpt_No&isPreview=false`,
        { data: [{ Rpt_No: "" }], timeout: 0 }
      );
      console.log(result.data.before);
    }
    setLoading(false);
  };
  const OnTryRemoveData = async () => {
    setLoading(true);
    const datase: any[] = [];

    for (const tableName of reportTableNames) {
      const result = await client.delete(
        `preview/bmw/${tableName}/?key=Rpt_No`,
        { data: [{ Rpt_No: "" }], timeout: 0 }
      );
      console.log(result.data.before);

      datase.push(result.data.before);
    }
    setLoading(false);
    showModal(
      <ModalBase>
        <div className="w-[90%] h-[90%] p-5 bg-white">
          <Typography.Title level={5}>삭제될 데이터 목록</Typography.Title>
          <div className="h-5"></div>
          <div className="flex-col flex gap-3 h-[650px] overflow-scroll">
            <Table
              columns={
                datase[0].length > 0
                  ? Object.keys(datase[0][0])
                      .filter((k) => k !== "key")
                      .map((key) => ({
                        title: key,
                        dataIndex: key,
                        key,
                        render: (text: any) => (
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: 180,
                              cursor: "pointer",
                            }}
                            title={text}
                          >
                            {typeof text === "string" ||
                            typeof text === "number"
                              ? String(text)
                              : ""}
                          </div>
                        ),
                      }))
                  : []
              }
              dataSource={datase[0].map((row: any, idx: any) => ({
                key: idx,
                ...row,
              }))}
              bordered
              pagination={false}
              size="small"
            />
            <Table
              columns={
                datase[1].length > 0
                  ? Object.keys(datase[1][0])
                      .filter((k) => k !== "key")
                      .map((key) => ({
                        title: key,
                        dataIndex: key,
                        key,
                        render: (text: any) => (
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: 180,
                              cursor: "pointer",
                            }}
                            title={text}
                          >
                            {typeof text === "string" ||
                            typeof text === "number"
                              ? String(text)
                              : ""}
                          </div>
                        ),
                      }))
                  : []
              }
              dataSource={datase[1].map((row: any, idx: any) => ({
                key: idx,
                ...row,
              }))}
              bordered
              pagination={false}
              size="small"
            />
            <Table
              columns={
                datase[2].length > 0
                  ? Object.keys(datase[2][0])
                      .filter((k) => k !== "key")
                      .map((key) => ({
                        title: key,
                        dataIndex: key,
                        key,
                        render: (text: any) => (
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: 180,
                              cursor: "pointer",
                            }}
                            title={text}
                          >
                            {typeof text === "string" ||
                            typeof text === "number"
                              ? String(text)
                              : ""}
                          </div>
                        ),
                      }))
                  : []
              }
              dataSource={datase[2].map((row: any, idx: any) => ({
                key: idx,
                ...row,
              }))}
              bordered
              pagination={false}
              size="small"
            />
            <Table
              columns={
                datase[3].length > 0
                  ? Object.keys(datase[3][0])
                      .filter((k) => k !== "key")
                      .map((key) => ({
                        title: key,
                        dataIndex: key,
                        key,
                        render: (text: any) => (
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: 180,
                              cursor: "pointer",
                            }}
                            title={text}
                          >
                            {typeof text === "string" ||
                            typeof text === "number"
                              ? String(text)
                              : ""}
                          </div>
                        ),
                      }))
                  : []
              }
              dataSource={datase[3].map((row: any, idx: any) => ({
                key: idx,
                ...row,
              }))}
              bordered
              pagination={false}
              size="small"
            />
            <Table
              columns={
                datase[4].length > 0
                  ? Object.keys(datase[4][0])
                      .filter((k) => k !== "key")
                      .map((key) => ({
                        title: key,
                        dataIndex: key,
                        key,
                        render: (text: any) => (
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: 180,
                              cursor: "pointer",
                            }}
                            title={text}
                          >
                            {typeof text === "string" ||
                            typeof text === "number"
                              ? String(text)
                              : ""}
                          </div>
                        ),
                      }))
                  : []
              }
              dataSource={datase[4].map((row: any, idx: any) => ({
                key: idx,
                ...row,
              }))}
              bordered
              pagination={false}
              size="small"
            />
            <Table
              columns={
                datase[5].length > 0
                  ? Object.keys(datase[5][0])
                      .filter((k) => k !== "key")
                      .map((key) => ({
                        title: key,
                        dataIndex: key,
                        key,
                        render: (text: any) => (
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: 180,
                              cursor: "pointer",
                            }}
                            title={text}
                          >
                            {typeof text === "string" ||
                            typeof text === "number"
                              ? String(text)
                              : ""}
                          </div>
                        ),
                      }))
                  : []
              }
              dataSource={datase[5].map((row: any, idx: any) => ({
                key: idx,
                ...row,
              }))}
              bordered
              pagination={false}
              size="small"
            />
          </div>

          <div className="w-full flex justify-center gap-2">
            <Button
              type="primary"
              danger
              style={{ fontWeight: "bold" }}
              icon={<RollbackOutlined />}
              onClick={hideModal}
            >
              롤백
            </Button>
            <Button
              icon={<CheckOutlined />}
              loading={loading}
              onClick={async () => {
                await OnDelete();
                hideModal();
              }}
            >
              적용하기
            </Button>
          </div>
        </div>
      </ModalBase>
    );
  };

  return (
    <div className=" flex flex-col h-screen w-full bg-gray-300 overflow-y-clip">
      {/* <div className="p-4 flex gap-2 justify-start items-center">
        <Button
          type="default"
          style={{ background: "white" }}
          onClick={() => {
            window.location.pathname = "/";
          }}
        >
          일반 일괄작업
        </Button>
        <div className="w-px h-10 bg-gray-400 mx-4" />
      </div> */}
      <div className="min-h-screen flex justify-center items-center bg-gray-100">
        <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
          <Card title="일괄 신고서 삭제 작업" style={{ width: 400 }}>
            <Button
              icon={<DeleteOutlined />}
              className="ant-btn ant-btn-default"
              onClick={OnTryRemoveData}
              loading={loading}
            >
              데이터 확인
            </Button>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ReportBatchRemover;
